<template>
  <div class="form-container">
    <div class="loader" v-if="isLoading">
        <div class="progress-circle-indeterminate"></div>
    </div>

    <form class="resource-form" v-if="render" :style="contractTerminated ? { pointerEvents: 'none' } : ''">

      <notifications v-if="anyError && !customNotif"
                    :error="formError"
                    :fields="fields"
                    :model="model"
                    :key="errorModule+'-notifications'">
      </notifications>

      <div v-for="(field, field_idx) in fields"
          :key="errorModule+'-field-'+field_idx"
          v-if="fields.length && !field.hidden"
          class="form-group tip"
          :class="generateDivClass(field)"
          :data-original-title="field.help"
          data-placement="bottom"
          data-toggle="tooltip">

        <label v-if="!compareFieldType(field, 'checkbox')" style="padding-right: 12px;">{{field.label}}</label>

        <custom-text v-if="compareFieldType(field, 'text')" :field="field" :value="values[field_idx]" :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-text>

        <custom-email v-else-if="compareFieldType(field, 'email')" :field="field" :value="values[field_idx]" :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-email>
        
        <custom-password v-else-if="compareFieldType(field, 'password')" :field="field" :value="values[field_idx]" :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-password>

        <custom-select v-else-if="compareFieldType(field, 'select')" :field="field" :value="values[field_idx]"
          :dropdownParent="dropdownParent" :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-select>

        <custom-checkbox v-else-if="compareFieldType(field, 'checkbox')" :field="field" :value="isSelected(field_idx)"
          :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)" :as_number="check_trigger_type_value(field_idx)">
        </custom-checkbox>

        <custom-text-area v-else-if="compareFieldType(field, 'textArea')" :field="field" :value="values[field_idx]"
          :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-text-area>

        <custom-switch  v-else-if="compareFieldType(field, 'switch')" :field="field" :value="values[field_idx]" :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)" :as_number="check_trigger_type_value(field_idx)">
        </custom-switch>

        <custom-datepicker v-else-if="compareFieldType(field, 'date')" :field="field" :value="values[field_idx]" :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-datepicker>

        <custom-timepicker v-else-if="compareFieldType(field, 'time')" :field="field" :value="values[field_idx]" :field_idx="field_idx"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-timepicker>

        <custom-datetimepicker v-else-if="compareFieldType(field, 'datetime')" :field="field" :value="values[field_idx]" :field_idx="field_idx" class="w150"
          @field-updated="handleFieldValueUpdated($event)">
        </custom-datetimepicker>

      </div>

      <div style="margin-top: 20px;">
        <button v-if="submitButton && !contractTerminated"
                type="submit"
                class="btn btn-primary btn-sm"
                @click.prevent="handleSubmit">
          Envoyer
        </button>
        <slot name="cancel"></slot>
      </div>

    </form>
  </div>
</template>

<script>
import Notifications from "./Notifications"
import CustomCheckbox from "./Elements/Checkbox"
import CustomDatepicker from "./Elements/Datepicker"
import CustomDateTimepicker from "./Elements/DateTimepicker"
import CustomEmail from "./Elements/Email"
import CustomPassword from "./Elements/Password"
import CustomSelect from "./Elements/Select"
import CustomSwitch from "./Elements/Switch"
import CustomText from "./Elements/Text"
import CustomTextArea from "./Elements/TextArea"
import CustomTimepicker from "./Elements/Timepicker"

import { FORM_ERROR, FORM_SUCCESS, FORM_UID_CHANGED } from 'store/mutation-types'

export default {
  name:"ResourceForm",
  props: {
      schema: {
        type: Object,
        required: true,
      },
      model: {
        type: Object,
        default: () => ({}),
      },
      triggers: {
        type: Object,
        default: () => ({}),
      },
      submitButton: {
        type: Boolean,
        default: true,
      },
      hub: Object,
      dropdownParent: {
        type: String,
        default: "",
      },
      realtimeUpdate: {
        type: Boolean,
        default: false
      },
      customNotif:{
        type:Boolean,
        default:false,
      },
      initialSubmit: {
        type: Boolean,
        default: false
      },
      contractTerminated: {
        type: Boolean,
        default: false
      },
      noFormGroup: {
        type: Boolean,
        default: false
      }
    },

  components:{
    Notifications,
    CustomCheckbox,
    CustomDatepicker,
    CustomDateTimepicker,
    CustomEmail,
    CustomPassword,
    CustomSelect,
    CustomSwitch,
    CustomText,
    CustomTextArea,
    CustomTimepicker
  },

  data(){
    return {
      isLoading: false,
      fields:[],
      values:[],
      errorModule:"",
      render:false,
      unwatchValues:null,
      unwatchErrors:null,
      scrolling: false,
    }
  },

  created() {
    this.render= false
    this.fields = _.reduce(
      this.schema.fields,
      (res, field) => {

        let trigger = this.isOptionalField(field.model),
          isOptional = !_.isNil(trigger),
          value = this.getModelField(field)

        field.hidden = false
        if (isOptional) {
          if (this.shouldHandleOptField(trigger, true)) {
            field.hidden = false
          } else {
            field.hidden = true
          }
        }
        field.required = this.handleFieldRequired(field)
        res.push(field)
        this.values.push(value)

        return res
      },
      []
    )
    this.unwatchErrors = this.$watch('anyError', this.errorsWatcher)
    this.render = true
  },

  mounted () {
    if (!this.submitButton && this.hub)
      this.hub.$on("submit-click", this.handleSubmit)
    else if (this.initialSubmit)
      this.handleSubmit()
  },

  beforeDestroy () {
    _.isNull(this.unwatchErrors) || this.unwatchErrors()
    this.setFormError({})
  },


  methods:{

    setFormError (error) {
      const mutationName = `FORM_ERROR`
      this.$store.commit(mutationName, error)
    },

    errorsWatcher (error) {
      if (error)
        this.$nextTick(() => {
          const $notifs = $('#notifications', this.$el),
            pos = $notifs.offset(),
            navHeight = $('.header').height() + 5
          if (pos)
            this.scrollToErrors(pos.top - navHeight)
        })
    },

    generateDivClass (field) {
      const required = field.required
      return {
        required,
        "input-group": this.compareFieldType(field, 'date'),
        "custom-form-group": !this.noFormGroup && !this.compareFieldType(field, 'date'),
        "form-group-default": !this.noFormGroup && this.compareFieldType(field, 'date')
      }
    },

    scrollToErrors (scrollTop = 0) {
      const $body = $('body, html')
      if (this.scrolling) {
        $body.stop()
        this.scrolling = false
      }
      this.scrolling = true
      $body.animate({ scrollTop }, 800,
        _ => this.scrolling = false)
    },

    isSelected (idx) {
      return this.values[idx] === true || this.values[idx] === 1
    },

    isOptionalField (model) {
      return _.find(this.processedTriggers, ['model', model])
    },

    handleFieldRequired (field) {
      if (field.hasOwnProperty("requiredIf")) {
        return this.parseRequiredIfTrigger(field.requiredIf)
      } else if (field.hasOwnProperty("required")) {
        return field.required
      }
      return false
    },

    getModelField (field) {
      return _.get(this.model, field.model, null)
    },

    shouldHandleOptField (trigger, initState = false) {
      const conditions = _.map(
        trigger.toWatch,
        ({ parse, model }) => {
          const idx = this.getFieldIndex(model),
            modelVal = initState ?
              this.getModelField({ model }) : this.values[idx]

          return parse(modelVal)
        }
      )
      return _.every(conditions)
    },
    getFieldIndex (model) {
      return _.findIndex(this.fields, ['model', model])
    },
    parseRequiredIfTrigger (trigger, initState = false) {
      const rules = _.split(trigger, ';'),
        conditions = _.map(rules, (rule) => {
          const [model, valueNeeded] = _.split(rule, ':'),
            value = initState ?
              this.getModelField({ model }) :
              this.values[this.getFieldIndex(model)]
          return valueNeeded === 'falsey' ?
            _.isEmpty(value) :
            value === valueNeeded
        })
      return _.every(conditions)
    },

    compareFieldType (field, type) {
      return field.type === type
    },

    dataToSend()
    {
      let ret = _.assign({}, this.model)
      _.each(this.fields, (field, idx) => {
        let value = this.values[idx]
        if (value && /date/.test(field.model)) {
          value = moment(value, "DD/MM/YYYY").format("YYYY-MM-DD")
        }
        _.set(ret, field.model, value)
      })
      return ret
    },

    handleSubmit () {
      this.$store.commit(FORM_UID_CHANGED, this.errorModule)
      this.setFormError({})
      /* Vuex plugins & API Interceptors will observe
       data return and will pin it for this instance
       using the dynamic module created before */
      if (this.hub)
        return this.hub.$emit('my-submit', this.dataToSend())
      this.$emit('submit', { data: this.dataToSend() })
    },

    check_trigger_type_value(field_idx)
    {
      let modelpath = this.fields[field_idx].model
      let res = false
      _.each(_.keys(this.triggers), tkey =>
        {
          let str_triggers = this.triggers[tkey]
          let all_triggers = str_triggers.split(';')
          let found2 = _.find(all_triggers, one_trigger =>
          {
            let name = one_trigger.split(':')[0]
            return name == modelpath
          })
          if(found2 != undefined)
            res = !isNaN(found2.split(':')[1])
        })
      return res
    },

    isTriggering(field)
    {
      console.warn(`Emitting Field name : ${field.model}`)
      let r = _.map(_.keys(this.triggers), (trigger_target_field_name) => {
            let str_all_conditions_required = this.triggers[trigger_target_field_name].split(';')
            let all_conditions_required = _.map(str_all_conditions_required, acr => {
              let data = acr.split(':')
              return {triggering_src:data[0], triggering_val:isNaN(data[1]) ? data[1] : Number(data[1])}
            })

            let found = _.find(all_conditions_required, acr => {
              return acr.triggering_src === field.model
            })
            return found != undefined ? _.assign(found, {target:trigger_target_field_name}) : undefined
        })
      return _.compact(r)
    },

    handleFieldValueUpdated(event)
    {
      if (event.new_value.hasOwnProperty("value")) {
        this.$set(this.values, event.idx, event.new_value.value)
      } else {
        this.$set(this.values, event.idx, event.new_value)
      }

      let concerned_field = this.fields[event.idx]
      let update_schema = false
      let fields = this.fields
      let values = this.values
      // console.warn(`Current Field name : ${concerned_model} with value : ${this.values[event.idx]}`)
      let triggered = this.isTriggering(concerned_field)
      if (triggered.length > 0)
        {
          // console.warn(`${JSON.stringify(triggered)}`)
          // console.warn(fields)
          _.each(triggered, trig => {
            let found = _.find(fields, f => f.model == trig.target)
            // console.warn(`${found.model}`)
            
            let comparisonValue = this.values[event.idx]
            if (this.values[event.idx] === false) {
              comparisonValue = "falsey"
            } else if (!isNaN(this.values[event.idx])) {
              comparisonValue = Number(this.values[event.idx])
            }

            if (trig.triggering_val === comparisonValue)
            {
              found.hidden = false
              // console.warn("Must be displayed")
            }
            else {
              found.hidden = true
              // console.warn("Must be hidden")
            }
            
            let idx = fields.indexOf(found)
            fields[idx] = found
          })
          // console.warn(fields)
          update_schema = true
        }
      if (update_schema)
      {
        this.fields = fields
        console.log("Schema updated")
      }
      this.render = false
      this.$forceUpdate()
      this.render = true
      if (this.realtimeUpdate)
        this.handleSubmit()
    }
  },

  computed:{
    processedTriggers () {
      return _.map(this.triggers, (rulesStr, model) => {
        const rules = _.split(rulesStr, ';'),
          toWatch = _.map(rules, (rule) => {
            const [model, valueNeeded] = _.split(rule, ':')
            let _value = Number(valueNeeded),
              parse = null
            if (!_.isNaN(_value)) {
              parse = (value) => !_.isNull(value) && Number(value) === _value
            } else if (valueNeeded === 'falsey') {
              parse = _.overSome([_.isNil, (val) => Number(val) === 0])
            } else {
              parse = (value) => value === valueNeeded
            }
            return { model, parse }
          })

        return {
          model,
          toWatch
        }
      })
    },
    formError () {
      return _.get(this.$store.state, ['formError'])
    },

    anyError () {
      return !_.isEmpty(this.formError)
    },
  },

  watch:{
    render : () => {
      if (this.realtimeUpdate)
        this.handleSubmit()
    }
  }

}
</script>

<style lang="scss" scoped>
  .form-container {
    position: relative;

    .loader {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(235, 235, 235, 0.5);
      z-index: 10;

      .progress-circle-indeterminate {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;
      }
    }
  }

  .custom-form-group {
    background-color: #fff;
    position: relative;
    border: 1px solid rgba(0, 0, 0, 0.07);
    border-radius: 2px;
    padding-top: 7px;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 4px;
    transition: background-color 0.2s ease;
  }
</style>



// WEBPACK FOOTER //
// client/components/Forms/ResourceForm.vue